import { NewUI_AppHeader } from "../../../../app/components/header/NewUI_component_Header/NewUI_AppHeader";
//import { V2_HeaderTabNav } from "../../../../app/components/header/component_Header/V2_HeaderTab";
import backgroundImageUrl from "./new_UI_Background_Image.png";
import { CardContainer } from "./tile/CardContainer";

const NewUI_Shell = ({ renderAppHeader, renderAppFooterMain, renderRoutes_V2_Demo, classes, isPrompt, isCopilot, renderAppFooter }) => {

    return (
        <div
            style={{
                backgroundImage: `url(${backgroundImageUrl})`,
                backgroundSize: 'cover',  // Make sure the image covers the entire div
                backgroundPosition: 'center',  // Center the image
                height: '100vh',  // Set height to 100% of the viewport height
            }}
        >
            {renderAppHeader && renderAppHeader()}

            <main id="main" className={classes.main} tabIndex={-1}>
                {!isPrompt && !isCopilot && renderRoutes_V2_Demo()}
            </main>
            {!isPrompt && renderAppFooter()}
            {/* Add components here */}
            {renderAppFooterMain && renderAppFooterMain()}

        </div>
    );
};

export default NewUI_Shell;
